import { CloudinaryProductAsset, CloudinaryProductAssetGroup } from 'shared/types/content';
import { ImageProps } from 'components/commercetools-ui/atoms/image';
import { dedupeCloudinaryImages } from './cloudinaryAssetToImage';

export const getProductGalleryImages = (
  group: CloudinaryProductAssetGroup | undefined,
  shared: CloudinaryProductAsset[] | undefined,
  sku: string,
  variantImages: string[] = [],
): ImageProps[] => {
  const cloudinaryImages = dedupeCloudinaryImages([
    ...(group?.primary.slice(0, 1) ?? []),
    ...(group?.additional ?? []),
    ...(shared ?? []),
  ]);

  if (cloudinaryImages.length) return cloudinaryImages;

  return variantImages.map((src, index) => ({
    id: `${sku}-${index}`,
    src,
    alt: sku,
  }));
};
